import axios, { InternalAxiosRequestConfig } from "axios";
import { refreshTokenUrl } from "../const/URL";
import { logout } from "../store/actions/auth.action";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig<any>) => {
    const accessToken = localStorage.getItem("enterprise_portal_access_Token");

    if (config.headers) {
      if (accessToken) {
        config.headers["Authorization"] = "Bearer " + accessToken;
      }
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    const accessToken = localStorage.getItem("enterprise_portal_access_Token");
    const refreshToken = localStorage.getItem(
      "enterprise_portal_refresh_token"
    );

    if (accessToken && refreshToken) {
      if (
        error.response.status === 401 &&
        originalRequest.url === refreshTokenUrl
      ) {
        logout();
        localStorage.removeItem("enterprise_portal_access_Token");
        localStorage.removeItem("enterprise_portal_refresh_token");
        // localStorage.removeItem('userImage')
        window.location.reload();
      } else if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        const refreshToken = localStorage.getItem(
          "enterprise_portal_refresh_token"
        );

        let headers = {
          Authorization: refreshToken ? `Bearer ${refreshToken}` : "",
        };
        return axios
          .post(refreshTokenUrl, null, { headers })
          .then((response) => {
            if (response.data.hasOwnProperty("isSuccess")) {
              logout();
              localStorage.removeItem("enterprise_portal_access_Token");
              localStorage.removeItem("enterprise_portal_refresh_token");
              // localStorage.removeItem('userImage')
              window.location.reload();
            } else {
              localStorage.setItem(
                "enterprise_portal_access_Token",
                response.data.accessToken
              );
              localStorage.setItem(
                "enterprise_portal_refresh_token",
                response.data.refreshToken
              );
              axiosInstance.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.accessToken;
              return axiosInstance(originalRequest);
            }
          })
          .catch(() => {
            logout();
            localStorage.removeItem("enterprise_portal_access_Token");
            localStorage.removeItem("enterprise_portal_refresh_token");
            window.location.reload();
          });
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
